<script setup>
  import { inject } from 'vue';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 1,
    },
  });

  const onMenuItemClick = inject('onMenuItemClick');

  function clickHandler(event) {
    // If this item has children, prevent the click from propagating (for NavDrawerGroup)
    if (props.item.children) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    onMenuItemClick?.(props.item);
  }
</script>

<template>
  <v-list-item
    v-bind="$attrs"
    :value="item.title"
    :data-id="item.id"
    :active="$page.url === item.to"
    @click="clickHandler"
    class="cognito-navdrawer__item"
    :class="['level-' + level, { menuHome: item.id === 'menuHome' }]"
    active-class="cognito-navdrawer__item--active"
    density="compact"
    rounded="lg"
  >
    <template #prepend>
      <NavDrawerIcon :icon-name="item.icon" :icon-type="item.iconType" :level="level" />
    </template>

    <v-list-item-title class="text-wrap">{{ item.title }}</v-list-item-title>
  </v-list-item>
</template>
